<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card" :body-style="{ padding: '8px' }">
            <el-page-header content="退款记录" :icon="null" title="退款管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">刷新</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%;margin-top: 8px;" height="calc(100vh - 193px)"
                row-key="id" v-loading="state.tableLoading">
                <el-table-column prop="userPhone" label="手机号码" min-width="120px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.userPhone }">
                            <span>手机号码</span>
                            <el-icon ref="triggerRefUserPhone">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="applicationRefundAmount" label="退款金额" min-width="100px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row.applicationRefundAmount / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="refundStatus" label="退款状态" min-width="130px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.refundStatus }">
                            <span>退款状态</span>
                            <el-icon ref="triggerRefRefRefundStatus">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                    <template #default="scope">
                        <el-text class="mx-1" type="success" v-if="scope.row.refundStatus == '已退款'">
                            {{ scope.row.refundStatus }}
                        </el-text>
                        <el-text class="mx-1" type="error"
                            v-else-if="scope.row.refundStatus == '拒绝' || scope.row.refundStatus == '已拒绝'">
                            {{ scope.row.refundStatus }}
                        </el-text>
                        <el-text class="mx-1" type="warning" v-else>
                            {{ scope.row.refundStatus }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="refundType" label="退款类型" min-width="180px" />
                <el-table-column prop="refundReason" label="退款/拒绝原因" min-width="180px" />
                <el-table-column prop="orderNumber" label="支付订单" min-width="200px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.orderId }">
                            <span>支付订单</span>
                            <el-icon ref="triggerRefRefOrderId">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="refundSerialNumber" label="退款编号" min-width="300px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.refundSerialNumber }">
                            <span>退款编号</span>
                            <el-icon ref="triggerRefRefUndSerialNumber">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="applicationTime" label="退款时间" min-width="180px">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.daterange }">
                            <span>退款时间</span>
                            <el-icon @click="dateRangeFilter" ref="triggerRefDaterange">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="refundTime" label="退款完成的时间" min-width="180px" />
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <!-- 筛选popover -->
    <FilterPhone @handleSearch="handleSearch" :triggerRef="triggerRefUserPhone" field="userPhone" :formValue="search" />
    <FilterText @handleSearch="handleSearch" :triggerRef="triggerRefRefUndSerialNumber" field="refundSerialNumber"
        :formValue="search" placeholder="请输入退款编号" />
    <FilterText @handleSearch="handleSearch" :triggerRef="triggerRefRefOrderId" field="orderId" :formValue="search"
        placeholder="请输入支付订单号" />
    <FilterSelect @handleSearch="handleSearch" :triggerRef="triggerRefRefRefundStatus" field="refundStatus"
        :formValue="search" :options="state.options" placeholder="请选择退款状态" />
    <FilterDateRange @handleSearch="handleSearch" ref="popoverRefDaterange" :triggerRef="triggerRefDaterange"
        field="daterange" :formValue="search" />
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { Filter } from '@element-plus/icons-vue'
import { getRefundListFun } from "@/api/refund"
import { formatCurrency } from "@/util/formValidator";
import FilterPhone from '@/components/TableFilter/FilterPhone.vue'
import FilterText from '@/components/TableFilter/FilterText.vue'
import FilterSelect from '@/components/TableFilter/FilterSelect.vue'
import FilterDateRange from '@/components/TableFilter/FilterDateRange.vue'

const triggerRefUserPhone = ref();// 手机号筛选ref
const triggerRefRefUndSerialNumber = ref();// 退款编号筛选ref
const triggerRefRefOrderId = ref();// 支付订单筛选ref
const triggerRefRefRefundStatus = ref();// 退款状态筛选ref
const triggerRefDaterange = ref();// 退款时间筛选
const popoverRefDaterange = ref();// 退款时间筛选

const search = reactive({
    userPhone: "",
    refundSerialNumber: "",
    orderId: '',
    refundStatus: '',
    daterange: '',
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    options: [
        { label: "待处理", value: '待处理' },
        { label: "处理中", value: '处理中' },
        { label: "已退款", value: '已退款' },
        { label: "拒绝", value: '拒绝' },
    ],
})
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});
// 时间日期筛选点击
const dateRangeFilter = () => {
    popoverRefDaterange.value.state.visible = !popoverRefDaterange.value.state.visible;
}
// 列表查询
const handleSearch = () => {
    searchFun(1);
}
// 查询 1查询 2重置
const searchFun = (type) => {
    popoverRefDaterange.value.state.visible = false;
    if (type == 2) {
        search.userPhone = '';
        search.refundSerialNumber = '';
        search.orderId = '';
        search.refundStatus = '';
        search.daterange = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }

    for (let key in search) {
        if (search[key]) {
            if (key == 'daterange') {
                params.formValue['startTime'] = search[key][0];
                params.formValue['endTime'] = search[key][1];
                params.keys.push('startTime');
                params.keys.push('endTime');
            } else {
                params.keys.push(key);
                params.formValue[key] = search[key];
            }
        }
    }
    getRefundListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}

onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
:deep .el-card {
    box-shadow: none !important;
    border-radius: inherit;
    border: none;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 8px;
    float: right;
}


.dialog-content {
    height: 65vh;
}

.header-cell {
    width: 100%;
    position: relative;

    :deep .el-icon {
        position: absolute;
        right: 0;
        font-size: 16px;
        line-height: 23px;
        font-weight: bold;
        display: inline-block;
        cursor: pointer;
        transition: all 0.2s;

        svg {
            height: 23px;
        }
    }

    :deep .el-icon:hover {
        color: #409eff;
    }
}

.header-cell_active {
    :deep .el-icon {
        color: #409eff;
    }
}
</style>